import Icon from "@/components/Icon/Icon";
import { VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { cn } from "@/lib/cn";

interface EmptyStateFeedBackProps {
  title: string;
  description: string;
  className?: string;
}

export const EmptyStateFeedBack = ({
  title,
  description,
  className,
}: EmptyStateFeedBackProps) => {
  return (
    <VStack
      className={cn(
        "items-center border-2 rounded-md justify-center gap-2 text-center h-full",
        className,
      )}
    >
      <Icon iconName="NoLogoIcon" size={32} />
      <Text variant="h4" className="mb-2">
        {title}
      </Text>
      <Text
        variant="label"
        className={cn("text-muted-foreground max-w-[400px]")}
      >
        {description}
      </Text>
    </VStack>
  );
};
